exports.required = function (val) {
	if(val === "" || val === null) return false;
	return true;
}

exports.valid_mobile = function (val) {
  if (val.length > 3 && val.length < 16) return true;
  else return false;
}


// WEBPACK FOOTER //
// ./src/Utils/Validator.js